export default __webpack_public_path__ + "static/media/single-project-page-03-img15.c0f0d1f5.jpg";